import { StorageConstants } from '@linkie/shared';
import { create, type StateCreator } from 'zustand';
import { devtools, persist, createJSONStorage } from 'zustand/middleware';
import localforage from 'localforage';
import { createAuthStoreInitializer } from '@linkie/shared';
import type { AuthStore } from '@linkie/shared';

import { isLoggedIn } from '@/core/utils/is-logged-in';

export type { AuthStore } from '@linkie/shared';

export const authStoreName = StorageConstants.IDENTITY;

const indexedDBStorage = createJSONStorage(() => ({
  getItem: async (name): Promise<string | null> => {
    const value = await localforage.getItem(name);
    return value ? JSON.stringify(value) : null;
  },
  setItem: async (name, value: string) => {
    try {
      const parsed = JSON.parse(value);
      await localforage.setItem(name, parsed);
    } catch (error) {
      console.error('[AuthStore] Failed to parse value for IndexedDB', error);
    }
  },
  removeItem: async (name) => {
    await localforage.removeItem(name);
  },
}));

const createAuthStore = (): StateCreator<AuthStore> => {
  const baseStore = createAuthStoreInitializer();

  if (!isLoggedIn()) {
    return baseStore;
  }

  return persist(baseStore, {
    name: authStoreName,
    version: 0,
    storage: indexedDBStorage,
    onRehydrateStorage: () => (state) => {
      console.log('[AuthStore] Hydrated', state);
    },
  }) as unknown as StateCreator<AuthStore>;
};

export const useAuthStore = create<AuthStore>()(devtools(createAuthStore()));
